export default {
  INCREASE_searchCounter(state) {
    state.searchCounter += 1;
  },
};
